<template>
          <div style="position: relative;">
            <img :src="payBgImage" alt="" style="width: 100%;display: block;" />

            <div style="position: absolute; top: 0;left: 0;right: 0;bottom: 0;display: flex;flex-direction: column;align-items: center;justify-content: center;">
                 <div style="display: flex">
                    <img :src="payLockImage" alt="" class="icon" />
                    <div class="title">
                        <div>
                          <span>{{ L("本文未完，本篇为") }}</span>
                          <span style="color: #C18D30;">{{ L('VIP文章') }}</span>
                        </div>
                        <div>
                          <span>{{ L('需') }}</span>
                          <span style="color: #C18D30;">{{ L('付费解锁') }} {{ item.price }} 元</span>
                        </div>
                    </div>
                </div>

                <div class="button-group">
                  <LoginButton>
                    <div class="button">{{ L('已是VIP?登入') }}</div>
                  </LoginButton>
                  <div class="button primary" @click="visible = true">{{ L("付费解锁") }}</div>
                </div>

            </div>





<el-dialog
  :title="L('选择支付方式')"
      :visible.sync="visible"
      width="300px"
    >
            <div style="display: flex;align-items: center;justify-content: center;padding: 16px 0;">
              <el-radio-group v-model="paymentType">
      <el-radio label="WAC2B">{{ L("支付宝") }}</el-radio>
      <el-radio label="WUC2B">{{ L('银联') }}</el-radio>
    </el-radio-group>
            </div>

      <span slot="footer" class="dialog-footer">
       <el-button @click="visible = false">{{ L('关闭') }}</el-button>
        <el-button type="primary" @click="unlock" :loading="payLoading || qrcodeLoading">{{ L('确定') }}</el-button>
       </span>
    </el-dialog>

<el-dialog
  title="支付"
      :visible.sync="payVisible"
      width="300px"
    >
      <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;padding: 24px;">
        <img :src="qrcode" alt="" style="width: 240px;border-radius: 8px;margin-bottom: 16px;">
        <div>{{ L(paymentType === 'WAC2B' ? '请使用支付宝扫一扫' : '请使用云闪付扫一扫') }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
       <el-button @click="cancel">{{ L('关闭') }}</el-button>
        <el-button type="primary" @click="ok" :loading="statusLoading">{{ L('已支付') }}</el-button>
       </span>
    </el-dialog>



          </div>

</template>

<script>
  import payBgImage from '../../assets/pay-bg.png'
  import payLockImage from '../../assets/pay-lock.png'
  import LoginButton from './login-button.vue'
  import QRCode from 'qrcode'

  import { createNewsOrder , fetchOrderStatus } from "@/assets/api/magazine.js";


  export default {

    props: {
      item: {
        type: Object,
        default: '',
      }
    },

    components: {
      LoginButton,
    },
    data() {
      return {
        payBgImage,
        payLockImage,

        visible: false,
        paymentType: 'WAC2B',

        payLoading: false,

        orderDetail: {},

        payVisible: false,
        qrcodeLoading: false,
        qrcode: '',
        statusLoading: false,


      }
    },

    methods: {


    unlock() {
        const formData = new FormData();

        formData.append('newsId', this.item.newsId)
        formData.append('paymentType',this.paymentType)

          this.payLoading = true;
          createNewsOrder(formData).then(res => {
          this.payLoading = false;
          console.log('res', res);

          if (res && res.data && res.data.code === 0) {
            try {
              const result = JSON.parse(res.data.data);
              this.orderDetail = result;
              this.createQRCode(result.qrCode);
            } catch (error) {
              this.$message({
                message: L('参数格式不正确'),
                type: "error",
              });
            }
          } else {

            this.$message({
                message: L(res && res.data && res.data.msg ? res.data.msg : '异常错误'),
                type: "error",
            });
          }

        }).catch(err => {
          this.payLoading = false;
          this.$message({
                message: L(err.message),
                type: "error",
            });
        })


        },


    cancel() {
      this.orderDetail = {}
      this.payVisible = false;
      this.qrcode = '';
    },
    ok() {

      const formData = new FormData();
      formData.append('orderNo', this.orderDetail.orderNo)
      formData.append('paymentNo',this.orderDetail.outTrace)
      this.statusLoading = true;
      fetchOrderStatus(formData).then(res => {
        this.statusLoading = false;
        console.log('res', res);

        if (res && res.data && res.data.code === 0) {
          this.$message({
              message: L(res && res.data && res.data.msg ? res.data.msg : '异常错误'),
              type: "success",
          });

          this.cancel();

        } else {
          this.$message({
              message: L(res && res.data && res.data.msg ? res.data.msg : '异常错误'),
              type: "error",
          });
        }

      }).catch(err => {
        this.statusLoading = false;
        this.$message({
              message: L(err.message),
              type: "error",
          });
      })

    },

    createQRCode(str) {
      this.qrcodeLoading = true;
      QRCode.toDataURL(str)
        .then(url => {
          this.qrcodeLoading = false;
            this.qrcode = url;
            this.payVisible = true;

            this.visible = false;
        })
        .catch(err => {
          this.qrcodeLoading = false;
          console.error(err)
        })
    },



    }
  }
</script>

<style scoped>

  .icon {
    width: 48px; margin-right: 24px; display: block;
  }

  .title {
    display: flex;flex-direction: column;justify-content: space-around;font-weight: bold;
  }

  .button-group {
    display: grid;
    grid-template-columns: repeat(2,1fr);
    gap: 24px;
    margin-top: 40px;
  }

  .button {
    cursor: pointer;
    line-height: 36px;
    border-radius: 100px;
    text-align: center;
    border: 1px solid #C18D30;
    color: #C18D30;
    padding: 0 2em;
    font-size: 14px;
  }

   .primary {
    background-color: #C18D30;
    color: #fff;
  }


  @media screen and (max-width: 768px) {

    .icon {
      margin-right: 12px;
      width: 32px;
    }
    .title {
      font-size: 14px;
    }

      .button-group {
        gap: 12px;
        margin-top: 12px;
      }

      .button {
        line-height: 24px;
        padding: 0 1em;
        font-size: 12px;
      }
  }

</style>



// WEBPACK FOOTER //
// src/views/expert-details/read.vue